import React from 'react';
import { useAutoRefinanceMarketplace } from './hooks/autoRefinanceMarketplace.hook';
import { AutoRefinanceMarketplaceView } from './AutoRefinanceMarketplaceModuleView';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { useSeenModulePixel } from 'hook/helper.hook';
import { AUTO_REFINANCE } from 'types/morph.pagePosition.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useCommonAutoLoanHook } from '../AutoLoanMarketplaceModule/hooks/autoLoan.hook';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

const AutoRefinanceMarketplaceModuleController = props => {
  const {
    eventHandler,
    creditInfo,
    userInfo,
    getAutoRefinance,
    setRefinanceOffers,
    refinanceOffers,
    showAutoLoanList,
    autoLoanAccounts,
  } = props;

  const { commonStates, displayModal, hideModal, setCommonStates } =
    useCommonAutoLoanHook({
      eventHandler,
      moduleName: AUTO_REFINANCE,
    });

  const {
    state,
    handleAccountRadioClick,
    onSeeAutoRefinanceOffers,
    sortList,
    onApplyFilter,
    onSortBy,
    onRemoveTagFilter,
    setCurrentSortType,
  } = useAutoRefinanceMarketplace({
    creditInfo,
    userInfo,
    eventHandler,
    setCommonStates,
    getAutoRefinance,
    setRefinanceOffers,
    refinanceOffers,
    autoLoanAccounts,
    moduleName: AUTO_REFINANCE,
  });

  const loading = props.globalLoadingFlag;

  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: AUTO_REFINANCE,
    modulePosition: props.modulePosition,
    vertical: AUTO_LOAN_VERTICAL,
  });

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <>
        {seenModuleTracking}
        <AutoRefinanceMarketplaceView
          {...props}
          {...state}
          {...commonStates}
          showAutoLoanList={showAutoLoanList}
          autoLoanAccounts={autoLoanAccounts}
          handleAccountRadioClick={handleAccountRadioClick}
          onSeeAutoRefinanceOffers={onSeeAutoRefinanceOffers}
          sortList={sortList}
          setCurrentSortType={setCurrentSortType}
          displayModal={displayModal}
          hideModal={hideModal}
          onApplyFilter={onApplyFilter}
          onSortBy={onSortBy}
          onRemoveTagFilter={onRemoveTagFilter}
          seenModuleTracking={seenModuleTracking}
          moduleName={AUTO_REFINANCE}
        />
      </>
    );
  }
};

export default AutoRefinanceMarketplaceModuleController;
